import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import ServiceHighlights from "../components/ServiceHighlights";
import ServicesOverview from "../components/ServicesOverview";
import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import PartnerMarquee from "../components/PartnerMarquee";
import HelpButton from "../components/HelpButton";
import { Reviews } from "../components/Reviews";
import SEO from "../components/SEO";

function Laadpaal() {
  return (
    <div className="min-h-screen bg-white page-transition pt-[99px] md:pt-[133px]">
      <SEO
        title="Laadpaal installatie in Arnhem - elektricieninarnhem026.nl"
        description="Laat uw laadpaal vakkundig installeren door onze gecertificeerde elektriciens in Arnhem. Veilig en toekomstbestendig laden aan huis."
        image="/images/banner.png"
      />
      <Header />
      <HeroSection
        title="Laadpaal installatie voor uw elektrische auto in Arnhem"
        description="Laat uw laadpaal vakkundig installeren door onze gecertificeerde elektriciens in Arnhem. Veilig en toekomstbestendig laden aan huis."
        imageSrc="/images/wallbox.png"
      />

      {/* Features Section */}
      <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1088px] mb-12 md:mb-16">
        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-none">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Professionele laadpaal installatie in Arnhem
            </h2>
            <p>
              Een laadpaal thuis is de meest comfortabele manier om uw
              elektrische auto op te laden. Onze experts in Arnhem zorgen voor
              een veilige installatie, inclusief de benodigde aanpassingen aan
              uw meterkast. We werken met alle gangbare merken en zorgen voor
              een installatie die voldoet aan alle veiligheidseisen.
            </p>

            <div className="h-9"></div>
            <Link
              to="/offerte"
              aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
              className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
              style={{ minWidth: "216px" }}
            >
              <span className="flex items-center gap-1">Offerte aanvragen</span>
            </Link>
          </div>
          <div className="order-1 md:-order-1">
            <div className="relative">
              <img
                alt="Laadpaal installatie"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/wallbox.jpeg"
              />
            </div>
          </div>
        </div>
      </section>

      <ServicesOverview />
      <FAQ />

      <ServiceHighlights />

      <Reviews />

      <PartnerMarquee />

      {/* CTA Section */}
      <div className="w-full cursor-pointer bg-[#FFD100] transition-opacity duration-150 hover:opacity-80">
        <Link
          to="/offerte"
          aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
        >
          <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1088px] text-center py-6 justify-between items-center">
            <div
              data-variant="h2"
              className="font-bold leading-[1.25] text-[28px] lg:text-[36px] self-center text-white mb-0"
            >
              Offerte aanvragen
            </div>
          </section>
        </Link>
      </div>

      <HelpButton />
      <Footer />
    </div>
  );
}

export default Laadpaal;
